"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var queue = [];
var _default = queue;
exports.default = _default;